import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pusher from 'pusher-js';

import { MESSAGE_PUSHER } from '../../constants';

import { setOrganizationSeatsFilter } from '../../components/CMS/Organizations/ManageSeats/OrganizationSeats/actions';
// import { updateSubscriberUser } from '../../components/CMS/Subscriber/GlobalStates/CurrentUser/actions';

const ThePusher = () => {
     const dispatch = useDispatch();
     const user = useSelector((state) => state.subscriber.user);

     const handlePusher = () => {
          if (!user?.id) return;

          const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
               cluster: process.env.REACT_APP_PUSHER_CLUSTER,
          });

          const userChannel = pusher.subscribe(`channel-${user.id}`);

          // Called when user claim seat success
          userChannel.bind(MESSAGE_PUSHER.CLAIM_SEAT, (data) => {
               dispatch(setOrganizationSeatsFilter(null));
          });

          // // Called when update user certificate level
          // userChannel.bind(MESSAGE_PUSHER.UPDATE_USER_CERTIFICATE_LEVEL, (data) => {
          //      dispatch(updateSubscriberUser(data));
          // });

          return () => {
               userChannel.unbind();
          };
     };

     useEffect(handlePusher, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

     return <></>;
};

export default ThePusher;
